import React from 'react'
import { Box } from "@mui/material";
import './spereation.css';


function Spereation () {

  return (

    <Box className="seperation">


      
    </Box>

  )

}

export default Spereation
